<template>
  <div class="ai-markdown">
    <MarkdownRender
      :content="text || ''"
      :final="final"
      :max-live-nodes="0"
      :batch-rendering="true"
      :typewriter="false"
    />
  </div>
</template>

<script>
import MarkdownRender from 'markstream-vue';

export default {
  name: 'AiMarkdown',
  components: { MarkdownRender },
  props: {
    text: { type: String, default: '' },
    final: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.ai-markdown {
  font-size: 14px;
  line-height: 1.5;
}

.ai-markdown :deep(p) {
  margin: 0 0 6px;
}

.ai-markdown :deep(p:last-child) {
  margin-bottom: 0;
}

.ai-markdown :deep(h1),
.ai-markdown :deep(h2),
.ai-markdown :deep(h3),
.ai-markdown :deep(h4) {
  font-size: 15px;
  font-weight: 600;
  margin: 8px 0 4px;
}

.ai-markdown :deep(ul),
.ai-markdown :deep(ol) {
  margin: 4px 0;
  padding-left: 18px;
}

.ai-markdown :deep(li) {
  margin: 2px 0;
}

.ai-markdown :deep(table) {
  font-size: 13px;
}

.ai-markdown :deep(pre),
.ai-markdown :deep(code) {
  font-size: 13px;
}

.ai-markdown :deep(blockquote) {
  margin: 6px 0;
  padding-left: 10px;
  border-left: 3px solid #d1d5db;
  color: #6b7280;
}
</style>
